module.exports = __webpack_public_path__ + "static/media/neslon-mandela.335e4835.png";